/**
 * Created by yangrui on 2021/4/15.
 */
'use strict';
const list2 = [
    {
        title: '基本信息',
        ref:'myForm_1',
        zhuyi:'注意：保费按照原支付路径退回到原来账户',
        dataList: [
            {
                label: '担保金额(元)',
                key:'nDbje',
                required:true,
                disabled:true,
                value: '',
                unit:'元'
            },
            {
                label: '保单号',
                key:'cDbh',
                required:true,
                disabled:true,
                value: '',
            },
            {
                label: '保全法官联系电话',
                key:'cFglxdh',
                value: '',
                maxlength:20
            },
            {
                label: '创建申请日期',
                key:'dtCreatetime',
                required:true,
                disabled:true,
                value: new Date(),
                type: 'date',
            },
            {
                label: '退保类型',
                key:'nTblx',
                required:true,
                value: '',
                type: 'dropdown',
                // source: 'options_taitou_lx'
                source: 'codeList_902002'
            },
            {
                label: '类型描述',
                key:'cLxms',
                required:true,
                type: 'textarea',
                value: '',
                maxlength:200
            },
        ]
    },
];

const list3=[
    {
        title:'退保信息',
        type:'tbxx',
        dataList:[
            {
                name:'',
                key:'other',
                power:'0',
                value:'您提交的退保申请正在审核中，请耐心等待！'
            },
            {
                name:'审核结果',
                key:'nShjg',
                power:'1,2'
            },
            {
                name:'不通过原因',
                key:'cBtgyy',
                power:'2'
            },
            {
                name:'审核人',
                key:'cShr',
                power:'0,1,2'
            },
            {
                name:'审核人联系方式',
                key:'cShrlxfs',
                power:'0,1,2'
            },
            {
                name:'审核日期',
                key:'dtShrq',
                power:'1,2',
                type:'date'
            }

            ,
            {
                name:'退保处理时间',
                key:'dtTbclsj',
                power:'1',
                type:'date'
            },
            {
                name:'预计到账时间',
                key:'cYjdzsjts',
                power:'1'
            },
            {
                name:'退保金额',
                key:'nTbje',
                power:'1',
                unit:'元'
            },
            {
                name:'是否全额退保',
                key:'nSfqetb',
                power:'1'
            },
            {
                name:'未全额退保原因',
                key:'cWqetbyy',
                power:'1'
            }

        ],
    },
    {
        title:'基本信息',
        dataList:[
            {
                name:'担保金额(元)',
                key:'nDbje',
                unit:'元'
            },
            {
                name:'保单号',
                key:'cDbh'
            },
            {
                name:'保全法官联系电话',
                key:'cFglxdh'
            },
            {
                name:'创建申请日期',
                key:'dtCreatetime',
                type:'date'
            },
            {
                name:'退保类型',
                key:'nTblx'
            },
            {
                name:'类型描述',
                key:'cLxms'
            },
        ],
    },

    {
        title:'上传材料',
        type:'sccl',
        dataList:[
            {
                name:'退保申请书',
                key:'tbsqs',
                value:[]
            },
            {
                name:'退保依据证明材料',
                key:'tbyjzmcl',
                value:[]
            },
            {
                name:'其他材料',
                key:'qtcl',
                value:[]
            }
        ],
    },
];

const arrList2={
    options_taitou_lx: [{
        value: '1',
        label: '企业'
    }, {
        value: '2',
        label: '个人'
    }]
};

let formData2={};
list2[0].dataList.map(item2=>{
    formData2[item2.key]=item2.value;
})

let ruleList2=[];
list2.map(item=>{
    item.dataList.map(item2=>{
        ruleList2.push(item2);
    });
})

export {
    list2,
    list3,
    formData2,
    ruleList2,
    arrList2
}
